import { COLORS } from "../../constants";
import { UserColor } from "../../models";
import styles from "./styles.module.scss";

interface IProps {
  color: UserColor;
}

const UserColorBadge = ({ color }: IProps) => {
  const backgroundColor =
    color === "1_new_red"
      ? COLORS.red
      : color === "2_trial_red"
      ? COLORS.red
      : color === "3_trial_orange"
      ? COLORS.orange
      : color === "4_user_red"
      ? COLORS.red
      : color === "5_user_orange"
      ? COLORS.orange
      : color === "6_new_green"
      ? COLORS.green
      : color === "7_trial_green"
      ? COLORS.green
      : color === "8_user_green"
      ? COLORS.green
      : COLORS.gray;

  return <div className={styles.wrapper} style={{ backgroundColor }}></div>;
};

export default UserColorBadge;
